/// <amd-module name="Test/TestCaseResults/Redux/TestCaseResultsReducer" />
import produce from "immer";

import { TestCaseResultsActions, TestCaseResultsActionsTypes } from "./TestCaseResultsActions";
import { ITestCaseResultsState } from "./TestCaseResultsContracts";

/**
 * TestCaseResultsReducer: Reducer for test results page.
 */
export function TestCaseResultsReducer(state: ITestCaseResultsState, action: TestCaseResultsActions): ITestCaseResultsState {
    state = state || ({} as ITestCaseResultsState);

    return produce(state, (draftState: ITestCaseResultsState) => {
        switch (action.type) {
            case TestCaseResultsActionsTypes.loadInitialResultsDataSucceeded:
                draftState.testCaseName = action.payload.testCaseName;
                draftState.testCaseResults = action.payload.results;
                draftState.contextPoint = action.payload.contextPoint;
                break;
            case TestCaseResultsActionsTypes.changeColumnWidths:
                if (!draftState.columnAndWidthMap) {
                    draftState.columnAndWidthMap = {};
                }
                draftState.columnAndWidthMap[action.payload.columnId] = action.payload.width;
                break;
            default:
                break;
        }
    });
}
